import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import moment from "moment";
import useInactivityTimer from "hooks/useInactivityTimer";

const InactiveSessionLogoutPopup = () => {

   const {
      showPopup,
      secondsLeft,
      continueSession: handleStayLoggedIn,
      logoutUser: handleLogout,
      logoutLoading,
    } = useInactivityTimer();
  
    // console.log("secondsLeft", secondsLeft);

  // Format remaining time into mm:ss or X minutes Y seconds
  const formatTime = (seconds) => {
    const duration = moment.duration(seconds, "seconds");

    if (duration.asMinutes() >= 1) {
      return `${duration.minutes()} minute${duration.minutes() !== 1 ? "s" : ""} ${
        duration.seconds()
      } second${duration.seconds() !== 1 ? "s" : ""}`;
    }
    return `${duration.seconds()} second${duration.seconds() !== 1 ? "s" : ""}`;
  };

  return (
    <Modal
      show={showPopup}
      onHide={handleLogout}
      backdrop="static"
      keyboard={false}
      centered
      className="FormPop session-timeout-modal"
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>Session Timeout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="justify-content-center">
          <Col lg="12" className="main-content text-center">
            <p>
              Your session will expire soon. For security reasons, you'll be logged out in{" "}
              <strong>{formatTime(secondsLeft)}</strong>.
            </p>
            <p>If you wish to continue your session, click "Stay Logged In".</p>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <Button
                className="commonBtn btnSm"
                variant="secondary"
                onClick={handleStayLoggedIn}
              >
                Stay Logged In
              </Button>
              <Button
                className="btnSm"
                variant="danger"
                onClick={handleLogout}
                disabled={logoutLoading}
              >
                {logoutLoading ? "Logging out..." : "Logout Now"}
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default InactiveSessionLogoutPopup;
